'use client';

import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import { NotificationItem } from '@/src/app/components/Notification/types';
import Notification from '@/src/app/components/Notification/Notification';
import Toast from '@/src/app/components/Toast/Toast';
function NotificationTransition(t0) {
  const $ = _c(13);
  const {
    id,
    message,
    type,
    onClose,
    isToast,
    isClosable,
    description
  } = t0;
  const [show, setShow] = useState(true);
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      setShow(false);
      setTimeout(() => {
        onClose();
      }, 1000);
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onItemClose = t1;
  let t2;
  if ($[2] !== description || $[3] !== id || $[4] !== isClosable || $[5] !== isToast || $[6] !== message || $[7] !== onItemClose || $[8] !== type) {
    t2 = isToast ? <Toast message={message} type={type} onClose={onItemClose} /> : <Notification id={id} message={message} type={type} onClose={onItemClose} isClosable={isClosable} description={description} />;
    $[2] = description;
    $[3] = id;
    $[4] = isClosable;
    $[5] = isToast;
    $[6] = message;
    $[7] = onItemClose;
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== show || $[11] !== t2) {
    t3 = <Transition show={show} as={Fragment} enter="transform ease-out duration-300 transition" enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enterTo="translate-y-0 opacity-100 sm:translate-x-0" leave="transition ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">{t2}</Transition>;
    $[10] = show;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export default NotificationTransition;